import React, { useState } from "react";
import DrawerCustom from "../../../../shared/general/Drawer";
import { useTranslation } from "react-i18next";
import {
    Box,
    DialogActions,
    MenuItem,
    Stack,
    styled,
    Typography,
} from "@mui/material";
import ButtonBlue from "../../../../shared/general/ButtonBlue";
import TextFieldTheme from "../../../../shared/general/TextFieldTheme";
import { addManager } from "../../../../../../actions/manager";

const StyledRoot = styled(Box)({
    padding: "16px",
    "& .MuiAutocomplete-root": {
        "& .MuiOutlinedInput-root": {
            padding: "13.5px 14px",
            paddingRight: "32px",
            "& input": {
                padding: 0,
            },
        },
    },
    "& .field-label": {
        paddingBottom: "4px",
        fontWeight: "500",
        fontSize: "14px",
    },
});

export const DrawerAddManager = (props) => {
    const { t, i18n } = useTranslation();
    const {
        open,
        setOpen,
        company,
        positionList,
        setOpenAlert,
        setAlertType
    } = props;

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        // idPositions: "",
        positionsName: ""
    });

    const [errors, setErrors] = useState({});

    const handleClose = () => {
        setOpen(false);
        setFormData({
            firstname: "",
            lastname: "",
            email: "",
            // idPositions: "",
            positionsName: ""
        });
        setErrors({});
    };

    const handleChange = (field) => (event) => {
        setFormData({ ...formData, [field]: event.target.value });
        setErrors({ ...errors, [field]: "" }); // clear error on change
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.firstname.trim()) newErrors.firstname = t("ThisFieldIsRequired");
        if (!formData.lastname.trim()) newErrors.lastname = t("ThisFieldIsRequired");
        if (!formData.email.trim()) {
            newErrors.email = t("ThisFieldIsRequired");
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = t("ThisFieldIsRequired");
        }
        if (!formData.positionsName) newErrors.positionsName = t("ThisFieldIsRequired");

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        try {
            setIsSubmitting(true);
            if (!validate()) {
                setOpenAlert(true);
                setAlertType("error");
                return;
            };

            const response = await addManager({
                ...formData,
                idCompany: company && company.idCompany
            });
            if (response && response.status === 201) {
                setOpenAlert(true);
                setAlertType("success");
            } else {
                setOpenAlert(true);
                setAlertType("error");
            };
        } catch (error) {
            setOpenAlert(true);
            setAlertType("error");
            console.error("Error submitting form:", error);
        } finally {
            handleClose();
            setIsSubmitting(false);
        };
    };

    return (
        <DrawerCustom
            open={open}
            anchor="right"
            title={t("AddManager")}
            onClose={handleClose}
            PaperProps={{
                sx: {
                    width: "100%",
                    maxWidth: "500px",
                },
            }}
        >
            <StyledRoot>
                <Stack spacing={2} sx={{ mb: 2, mt: 2 }}>
                    <TextFieldTheme
                        fullWidth
                        label={t("FirstName")}
                        value={formData.firstname}
                        onChange={handleChange("firstname")}
                        error={Boolean(errors.firstname)}
                        helperText={errors.firstname}
                    />
                    <TextFieldTheme
                        fullWidth
                        label={t("LastName")}
                        value={formData.lastname}
                        onChange={handleChange("lastname")}
                        error={Boolean(errors.lastname)}
                        helperText={errors.lastname}
                    />
                    <TextFieldTheme
                        fullWidth
                        label={t("Email")}
                        type="email"
                        value={formData.email}
                        onChange={handleChange("email")}
                        error={Boolean(errors.email)}
                        helperText={errors.email}
                    />
                    <TextFieldTheme
                        fullWidth
                        select
                        label={t("Position")}
                        value={formData.positionsName}
                        onChange={handleChange("positionsName")}
                        error={Boolean(errors.positionsName)}
                        helperText={errors.positionsName}
                    >
                        {positionList && positionList.map((item) => (
                            <MenuItem
                                key={item.idPositions}
                                value={item.positionsName}
                            >
                                <Stack>
                                    <Typography>
                                        {t("Department")}: {i18n.resolvedLanguage === "th" ? item.departmentName : item.departmentName_EN}
                                    </Typography>
                                    <Typography>
                                        {t("Section")}: {i18n.resolvedLanguage === "th" ? item.sectionName : item.sectionName_EN}
                                    </Typography>
                                    <Typography>
                                        {t("position")}: {i18n.resolvedLanguage === "th" ? item.positionsName : item.positionName_EN}
                                    </Typography>
                                </Stack>
                            </MenuItem>
                        ))}
                    </TextFieldTheme>
                </Stack>
                <DialogActions>
                    <ButtonBlue
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        {t("Save")}
                    </ButtonBlue>
                    <ButtonBlue
                        variant="text"
                        onClick={handleClose}
                    >
                        {t("Cancel")}
                    </ButtonBlue>
                </DialogActions>
            </StyledRoot>
        </DrawerCustom>
    );
};